import styled from 'styled-components';
import { useCallback, useEffect, useState } from 'react';
import Pagination from '../../components/pagination/Pagination';
import { useSearchParams } from 'react-router-dom';
import { ThemeData } from '../quantData';
import QuantService from '../../../service/quant/Quant';
import UserService from '../../../service/User';
import { useModal } from '../../../context/ModalContext';

const Quant3 = () => {
  // let list = [
  //   {
  //     region: '서울 서초구 양재동',
  //     roi: '3.7%',
  //     roe: '4.2%',
  //     category: '아파트',
  //     tags: ['안정형', '300평이하', '노후 40년 이하'],
  //   },
  // ];
  const [list, setList] = useState<
    Array<{
      roi: string;
      roe: string;
      region: string;
      category: string;
      tags: Array<string>;
      type: number;
      iidx: string;
    }>
  >([]);

  const [searchParams, setSearchParams] = useSearchParams();
  const index = Number(searchParams.get('index'));
  const selectedRegion = searchParams.get('region');
  const selectedCategory = searchParams.get('category');
  const item = ThemeData[index as number];

  const limit = 12;
  const [cuurentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const getCode = (region: string) => {
    const regObj = {
      전국: '',
      서울: '11',
      경기: '41',
      인천: '28',
      부산: '26',
      대전: '30',
      대구: '27',
      울산: '31',
      세종: '36',
      강원: '51',
      충북: '43',
      충남: '44',
      경북: '47',
      경남: '48',
      광주: '29',
      전북: '52',
      전남: '46',
      제주: '50',
    };
    return regObj[region as '전국'];
  };

  const getList = async () => {
    try {
      const result = await QuantService.list({
        theme: item.name.replace(' ', ''),
        category: (selectedCategory === '전체'
          ? ''
          : selectedCategory) as string,
        ctpCode: getCode(selectedRegion as string),
        limit: limit,
        offset: (cuurentPage - 1) * limit,
      });
      if (result.data) {
        setTotalCount(result.data.totalCount);
        setList(
          result.data.list.map((el: any) => {
            let tags = [];
            let type = 0;
            if (el.roi < 5 && el.roe < 7) {
              tags.push('안정형');
              type = 1;
            } else if (el.roi >= 5 && el.roi < 7 && el.roe >= 6 && el.roe < 9) {
              tags.push('안정추구형');
              type = 2;
            } else if (
              el.roi >= 7 &&
              el.roi < 10 &&
              el.roe >= 8 &&
              el.roe < 12
            ) {
              tags.push('위험중립형');
              type = 3;
            } else if (
              el.roi >= 10 &&
              el.roi < 15 &&
              el.roe >= 12 &&
              el.roe < 20
            ) {
              tags.push('적극투자형');
              type = 4;
            } else if (el.roi >= 15 && el.roe >= 20) {
              tags.push('공격투자형');
              type = 5;
            }

            tags.push(Math.ceil(el.pyeong / 10) * 10 + '평 이하');
            if (el.years) {
              tags.push('노후 ' + Math.ceil(el.years / 10) * 10 + '년 이하');
            }

            return {
              idx: el.quant_idx,
              region: el.region,
              roi: el.roi,
              roe: el.roe,
              category: el.category,
              tags: tags,
              iidx: el.iidx,
              type,
            };
          }),
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  const func = async () => {
    if (await UserService.userGrade()) {
      getList();
    } else {
      modalDispatch('MC1');
    }
  };

  const { modalDispatch } = useModal();

  useEffect(() => {
    if (cuurentPage === 1) {
      func();
    } else {
      setCurrentPage(1);
    }
  }, [selectedRegion, selectedCategory]);

  useEffect(() => {
    func();
  }, [cuurentPage]);

  return (
    <Box gap={24} style={{ paddingTop: '24px' }}>
      <Box gap={14} style={{ paddingInline: '16px' }}>
        <Box gap={14} style={{ alignItems: 'flex-start' }}>
          <TitleBox>
            <PageTitle>추천 물건</PageTitle>
          </TitleBox>
          <Text color="#616161" size={14} weight={500}>
            매각기일이 최대 4주 남은 물건들 중 추천해드립니다.
          </Text>
        </Box>
        <Description>
          <Text
            color="#F45551"
            size={13}
            weight={500}
            style={{ textAlign: 'start' }}
          >
            ※ 예상 수익률엔 해당 물건의 모든 리스크가 반영되지 않습니다.
          </Text>
          <Text
            color="#616161"
            size={13}
            weight={500}
            style={{ textAlign: 'start' }}
          >
            투자 전략에 참고용으로 사용하시길 바랍니다.
          </Text>
        </Description>
        <Sub_Description>
          <Text
            size={14}
            weight={500}
            color="#616161"
            style={{ whiteSpace: 'nowrap' }}
          >
            ・ROI : 총 투자비 대비 수익률
          </Text>
          <Text
            size={14}
            weight={500}
            color="#616161"
            style={{ whiteSpace: 'nowrap' }}
          >
            ・ROE : 자기자본 대비 매각수익률
          </Text>
        </Sub_Description>
      </Box>
      {list.length > 0 && (
        <ItemBox>
          {list.map((item, index) => (
            <Item
              key={index}
              onClick={async () => {
                window.open(`/auction/detail/${item.iidx}`, '_blank');
              }}
            >
              <Row style={{ justifyContent: 'space-between' }}>
                <Text
                  size={16}
                  weight={500}
                  color="#222222"
                  style={{ textAlign: 'start' }}
                >
                  {item.region}
                </Text>
                <Category_Badge>
                  <Text
                    size={12}
                    weight={700}
                    color="#008AFF"
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    {item.category}
                  </Text>
                </Category_Badge>
              </Row>
              <Row gap={16}>
                <Text size={16} weight={500} color="#222222">
                  ROI : <span style={{ color: '#008AFF' }}>{item.roi}</span>
                </Text>
                <Text size={16} weight={500} color="#222222">
                  ROE : <span style={{ color: '#008AFF' }}>{item.roe}</span>
                </Text>
              </Row>
              <Row gap={4}>
                {item.tags.map((tag, index) => (
                  <Tag key={index} type={index === 0 ? item.type : 6}>
                    <span>{tag}</span>
                  </Tag>
                ))}
              </Row>
            </Item>
          ))}
        </ItemBox>
      )}
      {list.length > 0 && (
        <Box style={{ padding: '0 16px 72px' }}>
          <Pagination
            currentPage={cuurentPage}
            totalPages={Math.ceil(totalCount / limit)}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            removeMargin={true}
          />
        </Box>
      )}
      {list.length === 0 && (
        <Blink_Box>현재 추천 가능한 물건이 없습니다.</Blink_Box>
      )}
    </Box>
  );
};

export default Quant3;

const Blink_Box = styled.div`
  width: 100%;
  height: 188px;
  gap: 16px;
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 72px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Category_Badge = styled.div<{ type?: number }>`
  border-radius: 9999px;
  padding-top: 5px;
  padding-right: 12px;
  padding-bottom: 5px;
  padding-left: 12px;
  border: 1px solid #008aff;
`;

const ItemBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 0 16px 16px;
`;

const Tag = styled.span<{ type: number }>`
  border-radius: 4px;
  padding-top: 4px;
  padding-right: 8px;
  padding-bottom: 4px;
  padding-left: 8px;
  background: ${(props) => {
    switch (props.type) {
      case 1:
        return '#E6F4FF';
      case 2:
        return '#F1FCF8';
      case 3:
        return '#FCF5F1';
      case 4:
        return '#F1EEFF';
      case 5:
        return '#FEEFF4';
      default:
        return '#70737C14';
    }
  }};
  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 12px;
    line-height: 145%;
    letter-spacing: calc(12px * -0.05);
    color: ${(props) => {
      switch (props.type) {
        case 1:
          return '#008AFF';
        case 2:
          return '#27A131';
        case 3:
          return '#EC5717';
        case 4:
          return '#836BF1';
        case 5:
          return '#F45551';
        default:
          return '#37383C9C';
      }
    }};
  }
`;

const Box = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap}px;
`;

const Row = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap}px;
  align-items: center;
`;

const TitleBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const PageTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  color: #171e26;
`;

const Description = styled(Box)`
  width: 100%;
  gap: 8px;
  border-radius: 16px;
  background: #fff8f8;
  align-items: center;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px;
`;

const Sub_Description = styled(Box)`
  gap: 4px;
  padding-top: 12px;
  padding-right: 16px;
  padding-bottom: 12px;
  padding-left: 16px;
  border-radius: 8px;
  background: #70737c0d;
  width: 100%;
  align-items: flex-start;
`;

const Text = styled.span<{ color: string; size: number; weight: number }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size}px;
  line-height: 145%;
  letter-spacing: ${(props) => props.size * -0.02}px;
  text-align: center;
  color: ${(props) => props.color};
`;

const Item = styled.button`
  width: 100%;
  border-radius: 16px;
  padding: 20px;
  gap: 8px;
  border: 1px solid #e5e8ea;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  :hover {
  }
  cursor: pointer;
`;
